import React from "react";
import { Link } from "react-router-dom";
import styles from "../Purchase/purchase.module.scss";
import { getCurrencyCode } from "../../../utils/currency";

export interface ForeignCurrencyNoticeProps {
  currency?: unknown;
  availability?: boolean;
}

// Stands in for PurchaseWidget on foreign-currency properties, which can't be
// bought from the wallet (wallet balances are Naira-only). Lister contact
// details aren't shown on the property page, so enquiries go to HomeBuddy's
// contact page instead.
const ForeignCurrencyNotice: React.FC<ForeignCurrencyNoticeProps> = ({
  currency,
  availability,
}) => {
  // Mirror PurchaseWidget: don't invite enquiries about a property that has
  // already been paid for.
  if (!availability) {
    return (
      <div className="widget">
        <div className={styles.buttonGroup}>
          <button className="btn theme-btn-1" disabled>
            Property Paid For
          </button>
        </div>
      </div>
    );
  }

  const code = getCurrencyCode(currency);
  const pricedIn = code ? `priced in ${code}` : "priced in a foreign currency";

  return (
    <div className="widget">
      <p>
        This property is {pricedIn} and can't be paid for from your wallet.
        Contact us to enquire about purchasing it.
      </p>
      <Link to="/contact" className="btn theme-btn-1 w-100">
        Contact Us
      </Link>
    </div>
  );
};

export default ForeignCurrencyNotice;
